module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/download-app-store-jp-f8fff026333b0d2e2877d8b7451f44c1.png";